// --- START OF FILE SideBarStyle.js ---

import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SideBarContainer = styled.aside`
  background: linear-gradient(160deg, #111, #2d2d2d, #111);
  width: 300px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  box-shadow: 5px 0px 15px rgba(0, 0, 0, 0.5);
  transform: translateX(${({ expanded }) => (expanded ? '0' : '-100%')});
  transition: transform 0.4s ease-in-out;
`;

export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`;

export const CloseButton = styled.button`
  background: #B17D2A;
  color: white;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px; 
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  z-index: 1001;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #d49a3f;
    transform: rotate(180deg) scale(1.1);
  }
`;

export const LogoContainer = styled.div`
  padding: 40px 20px 20px 20px;
  display: flex;
  justify-content: center;
`;

export const LogoLink = styled(Link)`
  display: inline-block;
  opacity: 0.8;
  transition: opacity 0.3s;
  
  img {
    width: 160px;
    height: auto;
  }
  
  &:hover {
    opacity: 1;
  }
`;

export const NavItemsContainer = styled.nav`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow-y: auto;
  padding: 0 15px;
`;

export const NavItem = styled.div`
  width: 100%;
  border-radius: 6px;
  
  a {
    text-decoration: none;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    border-radius: 6px;
    transition: all 0.3s ease;
  }

  a.active {
    background: #B17D2A;
    color: white;
  }

  &:hover a:not(.active) {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }
`;

export const NavFooter = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s;
  background-color: rgba(0,0,0,0.2);

  &:hover {
    color: white;
    background-color: #B17D2A;
  }
`;